import { IdCodeLabel } from 'src/app/core/models/IdCodeLabel';
import { ProfilDto } from 'src/app/core/models/profil-dto';

export class ActiviteDto {
  id?: number; // activiteId
  codeAnalytique: string;
  nomComptable: string;
  dateDebut?: Date;
  dateFin?: Date;
  miseEnSommeilSage: Boolean = false;
  nom: string;
  principale?: boolean;

  public constructor(init?: Partial<ActiviteDto>) {
    Object.assign(this, init);
    this.nom = this.codeAnalytique + ' - ' + this.nomComptable;
  }
}

export class AssociationMembreActiviteDto {
  id: number;
  // activite: ActiviteDto;
  activite: IdCodeLabel;
  membre: IdCodeLabel;
  debutAsso: Date;
  finAsso: Date;
  actPrincipale: boolean;
  profils: ProfilDto[];
  nfAssociees: boolean;
  // champs suivants readonly :
  debutActivite: Date;
  finActivite: Date;
  miseEnSommeilSage: boolean;
  public constructor(init?: Partial<AssociationMembreActiviteDto>) {
    Object.assign(this, init);
  }
}

export class MembreActivitesDto {
  id: number;
  membreActiviteList: AssociationMembreActiviteDto[];
  readOnly: boolean;
}

export class ActiviteMembresDto {
  id: number;
  debutAct: Date;
  finAct: Date;
  miseEnSommeilSage: boolean;
  activiteMembreList: AssociationMembreActiviteDto[];
  readOnly: boolean;
}
